module.exports = __webpack_public_path__ + "ab996453d04964755f03700b806674a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-parvulo.png
// module id = 112
// module chunks = 0